import { useSelector } from 'react-redux'
import { RootState } from 'types'
import { isEqual } from 'lodash'
import { forwardRef, PropsWithChildren } from 'react'
import cx from 'classnames'
import Styles from './FocusModeHidden.module.scss'

interface Props {
  className?: string
}

export const FocusModeHidden = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, className, ...rest }, fRef) => {
    const { showFocusMode } = useSelector(({ focusMode }: RootState) => focusMode, isEqual)

    return (
      <div className={cx(Styles.root, className, { [Styles.hidden]: showFocusMode })} ref={fRef} {...rest}>
        {children}
      </div>
    )
  },
)
